// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__wYJAa","consentsList":"PatientConsents_consentsList__jHURO","consentsListEmpty":"PatientConsents_consentsListEmpty__2qoTn"};